"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackPageView = trackPageView;
exports.setVehicleProgram = setVehicleProgram;
exports.getVehicleProgram = getVehicleProgram;
exports.setApplicationType = setApplicationType;
exports.trackVideoView = trackVideoView;
exports.trackVideoChapterClick = trackVideoChapterClick;
exports.trackTextView = trackTextView;
exports.trackSearchKeyword = trackSearchKeyword;
exports.trackSearchResultsTopicClick = trackSearchResultsTopicClick;
exports.trackEmptyResultsSearchKeyword = trackEmptyResultsSearchKeyword;
exports.trackExploreSceneClick = trackExploreSceneClick;
exports.trackExploreTopicClick = trackExploreTopicClick;
exports.trackBrowseFolderClick = trackBrowseFolderClick;
exports.trackBrowseTopicClick = trackBrowseTopicClick;
exports.trackTopPicksTopicClick = trackTopPicksTopicClick;
exports.trackPublicationFolderClick = trackPublicationFolderClick;
exports.trackPublicationTopicClick = trackPublicationTopicClick;
exports.trackFavoritesTopicAdded = trackFavoritesTopicAdded;
exports.trackRecentlyViewedTopicClick = trackRecentlyViewedTopicClick;
exports.trackTopicRatingUpvote = trackTopicRatingUpvote;
exports.trackTopicRatingDownvote = trackTopicRatingDownvote;
exports.trackChangeVehicleClick = trackChangeVehicleClick;
exports.trackRelatedTopicClick = trackRelatedTopicClick;
exports.default = void 0;

var _index = require("../index");

var _react = _interopRequireWildcard(require("react"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var _common = require("./common");

var _createBrowserHistory = _interopRequireDefault(require("history/createBrowserHistory"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/**
 * HOC as per example from official documentation
 * https://github.com/react-ga/react-ga/wiki/React-Router-v4-withTracker
 *
 * @param {Object} WrappedComponent
 * @returns {HOC}
 */


var withTracker = function withTracker(WrappedComponent) {
  var HOC =
  /*#__PURE__*/
  function (_Component) {
    _inherits(HOC, _Component);

    function HOC() {
      _classCallCheck(this, HOC);

      return _possibleConstructorReturn(this, _getPrototypeOf(HOC).apply(this, arguments));
    }

    _createClass(HOC, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // TODO: get rid of directly reading static configuration, these should arrive as props
        var _getConfig = (0, _index.getConfig)(),
            GOOGLE_ANALYTICS_DEBUG = _getConfig.GOOGLE_ANALYTICS_DEBUG,
            GA_APPLICATION_TYPE = _getConfig.GA_APPLICATION_TYPE;

        var host = window.location.host; // Init GA

        _reactGa.default.initialize((0, _common.getGaCode)(host), {
          debug: GOOGLE_ANALYTICS_DEBUG,
          titleCase: false,
          gaOptions: {}
        }); // Set application type if provided


        if (GA_APPLICATION_TYPE) {
          setApplicationType(GA_APPLICATION_TYPE);
        } // Subscribe to navigation events


        var history = (0, _createBrowserHistory.default)();
        history.listen(trackPageView);
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(WrappedComponent, this.props);
      }
    }]);

    return HOC;
  }(_react.Component);

  return HOC;
};

var _default = withTracker;
/**
 * Tracks page views on React router navigation
 *
 * @param {Object} location
 */

exports.default = _default;

function trackPageView(location) {
  // removing # just in case we will move away from hash router or consider server-side rendering
  // in that case all tracked URLs will remain the same
  var path = location.hash.substr(1);

  _reactGa.default.set({
    page: path
  });

  _reactGa.default.pageview(path);
}
/**
 * Updates the GA context with vehicle program dimension data
 *
 * "dimension1" is configured as "Vehicle Program" dimension
 *
 * @param {String} year
 * @param {String} brand
 * @param {String} model
 */


function setVehicleProgram(year, brand, model) {
  var vehicleProgramString = year + ' ' + brand + ' ' + model;

  _reactGa.default.set({
    dimension1: vehicleProgramString
  });
}
/**
 * Returns vehicle program if it was previously set with setVehicleProgram()
 *
 * This is a workaround for limitations of vehicle selector that doesn't allows you to read prior model/year
 *
 * TODO: remove this method when the vehicle selector in Subaru is refactored
 *
 * @return {String}
 */


function getVehicleProgram() {
  var tracker = _reactGa.default.ga().getAll()[0];

  try {
    return tracker.b.data.values[':dimension1'];
  } catch (e) {
    return null; // if we can't fetch the vehicle program data then empty value should be returned
  }
}
/**
 * Updates the GA context with application type (web/mobile/ivh/desktop/native/etc...)
 *
 * "dimension2" GA dimension should be configured as "Application Type"
 *
 * @param {String} type
 */


function setApplicationType(type) {
  _reactGa.default.set({
    dimension2: type
  });
}
/**
 * Tracks video views
 *
 * @param {String} title - video topic title
 */


function trackVideoView(title) {
  _reactGa.default.event({
    category: 'Content',
    action: 'Video Play',
    label: title
  });
}
/**
 * Tracks video views
 *
 * @param {String} title - topic title + chapter title to differentiate chapters from different videos and the same name
 */


function trackVideoChapterClick(title) {
  _reactGa.default.event({
    category: 'Content',
    action: 'Chapter Play',
    label: title
  });
}
/**
 * Track text topic views - text topic title
 *
 * @param {String} title
 */


function trackTextView(title) {
  _reactGa.default.event({
    category: 'Content',
    action: 'View Text',
    label: title
  });
}
/**
  * Tracks search keywords
  *
  * @param {String} keyword
  */


function trackSearchKeyword(keyword) {
  _reactGa.default.event({
    category: 'Search',
    action: 'Keyword Search',
    label: keyword
  });
}
/**
 * Tracks topic name that was clicked in the search results
 *
 * @param {String} title
 */


function trackSearchResultsTopicClick(title) {
  _reactGa.default.event({
    category: 'Search',
    action: 'Search Result Click',
    label: title
  });
}
/**
 * Tracks empty search results for keywords
 *
 * @param {String} keyword
 */


function trackEmptyResultsSearchKeyword(keyword) {
  _reactGa.default.event({
    category: 'Search',
    action: 'Empty Search Results',
    label: keyword
  });
}
/**
 * Tracks visual search scene clicks
 *
 * @param {String} title
 */


function trackExploreSceneClick(title) {
  _reactGa.default.event({
    category: 'Explore',
    action: 'Scene Click',
    label: title
  });
}
/**
 * Tracks visual search topic clicks
 *
 * @param {String} title
 */


function trackExploreTopicClick(title) {
  _reactGa.default.event({
    category: 'Explore',
    action: 'Topic Click',
    label: title
  });
}
/**
 * Tracks browse folder clicks
 *
 * @param {String} title
 */


function trackBrowseFolderClick(title) {
  _reactGa.default.event({
    category: 'Browse',
    action: 'Category Click',
    label: title
  });
}
/**
 * Tracks browse topic clicks
 *
 * @param {String} title
 */


function trackBrowseTopicClick(title) {
  _reactGa.default.event({
    category: 'Browse',
    action: 'Topic Click',
    label: title
  });
}
/**
 * Tracks top picks topic clicks
 *
 * @param {String} title
 */


function trackTopPicksTopicClick(title) {
  _reactGa.default.event({
    category: 'Promoted',
    action: 'Topic Click',
    label: title
  });
}
/**
 * Tracks folder clicks per publication
 *
 * @param {String} publication
 * @param {String} title
 */


function trackPublicationFolderClick(publication, title) {
  _reactGa.default.event({
    category: publication,
    action: 'Category Click',
    label: title
  });
}
/**
 * Tracks topic clicks per publication
 *
 * @param {String} publication
 * @param {String} title
 */


function trackPublicationTopicClick(publication, title) {
  _reactGa.default.event({
    category: publication,
    action: 'Topic Click',
    label: title
  });
}
/**
 * Tracks adding topic to favorites
 *
 * @param {String} title
 */


function trackFavoritesTopicAdded(title) {
  _reactGa.default.event({
    category: 'Favorites',
    action: 'Topic Added',
    label: title
  });
}
/**
 * Tracks clicks on recently viewed
 *
 * @param {String} title
 */


function trackRecentlyViewedTopicClick(title) {
  _reactGa.default.event({
    category: 'Recently Viewed',
    action: 'Topic Click',
    label: title
  });
}
/**
 * Tracks up-voting the topic
 *
 * @param {String} title
 */


function trackTopicRatingUpvote(title) {
  _reactGa.default.event({
    category: 'Topic Rating',
    action: 'Upvote',
    label: title
  });
}
/**
 * Tracks down-voting the topic
 *
 * @param {String} title
 */


function trackTopicRatingDownvote(title) {
  _reactGa.default.event({
    category: 'Topic Rating',
    action: 'Downvote',
    label: title
  });
}
/**
 * Tracks vehicle changes
 *
 * @param {String} beforeVehicle
 * @param {String} afterVehicle
 */


function trackChangeVehicleClick(beforeVehicle, afterVehicle) {
  _reactGa.default.event({
    category: 'Change Vehicle',
    action: 'Click',
    label: beforeVehicle + ' :: ' + afterVehicle
  });
}
/**
 * Track related topic click
 *
 * @param {String} fromTopic
 * @param {String} toTopic
 */


function trackRelatedTopicClick(fromTopic, toTopic) {
  _reactGa.default.event({
    category: 'Related Topic',
    action: 'Topic Click',
    label: fromTopic + ' :: ' + toTopic
  });
}